/**
 * Wrapper that triggers callback if a click event is out of and elements.
 * This function was created To minimize the instantiation scroll events
 * on the window object. In addition can take partner element for those with dynamic width
 * and heights
 * @param {array} conditions - Array of conditions to loop
 * @params {object} condition.targetA - Element targeted for an out of bounds event
 * @params {object} condition.targetB - Partner element for targetA if dynamic width/height
 * @params {func} condition.trigger - Retuns a truthy condition to allow for callback to proceed
 * @params {func} condition.callback - Event triggered click event is out of bounds
 **/
export const onOutOfBounds = function (conditions = []) {
	document.addEventListener('click', function (event) {
		conditions.forEach((condition) => {
			const { clientX, clientY } = event;
			const { trigger, targetA, targetB, callback } = condition;

			if (!callback || !targetA || !trigger || !trigger(event)) return;

			if (targetA && !targetB) {
				const bounds = targetA.getBoundingClientRect();
				const { x, y, width, height } = bounds;

				if (clientX < x || clientX > x + width) callback();
				if (clientY < y || clientY > y + height) callback();
				return;
			}

			const ABounds = targetA.getBoundingClientRect();
			const BBounds = targetB.getBoundingClientRect();

			let x = ABounds.x;
			let y = ABounds.y;
			let width = ABounds.width;
			let height = BBounds.height;

			if (ABounds.x > BBounds.x) {
				width = Math.abs(ABounds.width - BBounds.width);
				x = BBounds.x;
			}

			if (ABounds.y > BBounds.y) {
				height = Math.abs(ABounds.height - BBounds.height);
				y = BBounds.y;
			}

			if (clientX < x || clientX > x + width) callback();
			if (clientY < y || clientY > y + height) callback();
		});
	});
};
